import {clientInstanceStore} from "./white-label/white-label.slice.js";
import {filtersStore} from "./filters/filters.slice.js";
export default {
  ...clientInstanceStore.actions,
  ...filtersStore.actions
};
